(function () {
  'use strict';

  function initCartPage(root) {
    const forms = root.querySelectorAll('#NvqCartForm:not([data-nvq-bound])');

    forms.forEach((form) => {
      form.setAttribute('data-nvq-bound', 'true');

      function updateLine(line, quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity }),
        })
          .then((response) => response.json())
          .then(() => {
            window.location.reload();
          })
          .catch((err) => console.error('[NVQ] Cart update error', err));
      }

      form.querySelectorAll('[data-nvq-qty-decrease]').forEach((btn) => {
        btn.addEventListener('click', function () {
          const line = btn.getAttribute('data-line');
          const input = form.querySelector('[data-nvq-qty-input][data-line="' + line + '"]');
          const newQty = Math.max(0, parseInt(input.value, 10) - 1);
          updateLine(line, newQty);
        });
      });

      form.querySelectorAll('[data-nvq-qty-increase]').forEach((btn) => {
        btn.addEventListener('click', function () {
          const line = btn.getAttribute('data-line');
          const input = form.querySelector('[data-nvq-qty-input][data-line="' + line + '"]');
          const newQty = parseInt(input.value, 10) + 1;
          updateLine(line, newQty);
        });
      });

      form.querySelectorAll('[data-nvq-qty-remove]').forEach((btn) => {
        btn.addEventListener('click', function () {
          const line = btn.getAttribute('data-line');
          updateLine(line, 0);
        });
      });

      form.querySelectorAll('[data-nvq-qty-input]').forEach((input) => {
        input.addEventListener('change', function () {
          const line = input.getAttribute('data-line');
          const newQty = Math.max(0, parseInt(input.value, 10) || 0);
          updateLine(line, newQty);
        });
      });
    });
  }

  if (window.NVQ) {
    window.NVQ.register('cartPage', initCartPage);
    window.NVQ.runAll(document);
  }
})();